const trashSVG = `
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.8999 4.27505H17.0999M7.5999 13.7751V8.07505M11.3999 13.7751V8.07505M13.2999 17.5751H5.6999C4.65056 17.5751 3.7999 16.7244 3.7999 15.6751V5.22505C3.7999 4.70038 4.22523 4.27505 4.7499 4.27505H14.2499C14.7746 4.27505 15.1999 4.70038 15.1999 5.22505V15.6751C15.1999 16.7244 14.3492 17.5751 13.2999 17.5751ZM7.5999 4.27505H11.3999C11.9246 4.27505 12.3499 3.84972 12.3499 3.32505V2.37505C12.3499 1.85038 11.9246 1.42505 11.3999 1.42505H7.5999C7.07523 1.42505 6.6499 1.85038 6.6499 2.37505V3.32505C6.6499 3.84972 7.07523 4.27505 7.5999 4.27505Z" stroke="#908F92" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`

export default trashSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/trashSVG.js